import { IoMdInformationCircle } from 'react-icons/io'
import { Tooltip } from 'react-tooltip'

export const InformationTip = (props: {
  discription: string
  dataId: string
}) => {
  const { discription, dataId } = props
  return (
    <>
      <IoMdInformationCircle
        data-tooltip-id={dataId}
        style={{ cursor: 'pointer', color: '#5FB36E', fontSize: '1.2rem' }}
      />
      <Tooltip
        id={dataId}
        place="top-start"
        opacity={1}
        border="1px solid #ccc"
        style={{
          backgroundColor: `#eee`,
          color: '#222'
        }}
        content={discription}
      />
    </>
  )
}
